import {
  GET_CUSTOMER_CREDIT_CARD_REQUEST,
  LIST_CUSTOMER_CREDIT_CARDS_REQUEST,
  ADD_CUSTOMER_CREDIT_CARD_REQUEST,
  EDIT_CUSTOMER_CREDIT_CARD_REQUEST,
  DELETE_CUSTOMER_CREDIT_CARD_REQUEST,
  RESET_CUSTOMER_CREDIT_CARD_QUERY
} from './constants';

export const listCustomerCreditCards = (queryString) => ({
  type: LIST_CUSTOMER_CREDIT_CARDS_REQUEST,
  queryString
});

export const getCustomerCreditCard = (customerCreditCardId) => ({
  type: GET_CUSTOMER_CREDIT_CARD_REQUEST,
  customerCreditCardId
});

export const addCustomerCreditCard = (customerCreditCard, successFunction) => ({
  type: ADD_CUSTOMER_CREDIT_CARD_REQUEST,
  customerCreditCard,
  successFunction
});

export const editCustomerCreditCard = (
  customerCreditCardId,
  customerCreditCard,
  successFunction
) => ({
  type: EDIT_CUSTOMER_CREDIT_CARD_REQUEST,
  customerCreditCardId,
  customerCreditCard,
  successFunction
});

export const deleteCustomerCreditCard = (
  customerCreditCardId,
  successFunction
) => ({
  type: DELETE_CUSTOMER_CREDIT_CARD_REQUEST,
  customerCreditCardId,
  successFunction
});

export const resetCustomerCreditCardQuery = () => ({
  type: RESET_CUSTOMER_CREDIT_CARD_QUERY
});
